import { memo } from "react";
import { headerFiltroEmbarque } from "../../../../../../models/FiltroEmbarqueCompleto.ts";
import { useFiltro } from "../../../../../../contexts/FiltroContext.tsx";
import { motion } from "framer-motion";
import InputTags from "../../data-entry/InputTags.tsx";

function RenderHeaderFiltros() {
	const { filtroEmbarque } = useFiltro();

	return (
			headerFiltroEmbarque.map(({ key, title }, index) => (
				<motion.div
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					transition={{ duration: 0.2, delay: index * 0.05 }}
					key={key}
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                    }}
				>
					<InputTags
						key={`${key}-input`}
						title={title}
						filtroKey={key}
						tags={filtroEmbarque[key] || []}
					/>
				</motion.div>
			))
	);
}

export default memo(RenderHeaderFiltros);
